export default "__VITE_ASSET__QmHRzLGo__"